import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${layout.measurements.spacing025};

  ${media.smallOnly`
    height: auto;
  `}
`;
